<template>
  <div class="user-details-edit">
    <user-details-edit-card v-if="user"
                            :user="user"
                            :title="$t('candidate.edit.details', {name: candidateFullName})"
                            @submit="onSubmit">
    </user-details-edit-card>
  </div>
</template>
<script>
  import get from 'lodash/get'
  import cloneDeep from 'lodash/cloneDeep'
  import UserDetailsEditCard from 'src/views/admin/contacts/users/UserDetails/UserDetailsEditCard'
  import UserService from 'src/services/UserService'

  export default {
    name: 'candidate-details-edit',
    components: {
      UserDetailsEditCard
    },
    data () {
      const user = get(this.$store.state.candidate.currentCandidate, 'user', {})
      return {
        user: user ? cloneDeep(user) : null,
      }
    },
    computed: {
      candidate () {
        return this.$store.state.candidate.currentCandidate
      },
      candidateFullName () {
        if (!this.candidate) {
          return ''
        }
        return `${this.candidate.given_name} ${this.candidate.family_name}`
      }
    },
    watch: {
      'candidate.user' (newUser) {
        if (!newUser) {
          return
        }
        this.user = cloneDeep(newUser)
      }
    },
    methods: {
      async onSubmit (id, data) {
        await UserService.update(id, data)
      }
    },
  }
</script>
